.header {
    z-index: 1;
}

.chart {
    width: 100%;
    position: absolute;
    bottom: 16px;
}
